import React from 'react';
import dayjs from 'dayjs';
import _ from 'lodash';
import PropTypes from 'prop-types';

import {
    StyledCard,
    StyledCardContent,
    Text,
    ContainedButton,
    OutlinedButton,
    CalendarIcon,
} from '../../index';

const Overlap = '/resources/images/overlap.svg';

export const OverlapCard = ({ data, onCancelConfirm, onConfirm }) => {
    return (
        <StyledCard $width="400px">
            <StyledCardContent
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    rowGap: '10px',
                }}
            >
                <Text $fontSize="16px" $bold style={{ alignSelf: 'center' }}>
                    Opps! Session Time Overlap
                </Text>
                <img
                    src={Overlap}
                    style={{
                        alignSelf: 'center',
                        marginTop: '10px',
                        marginBottom: '10px',
                    }}
                />
                <Text $fontSize="14px" $bold>
                    Session - {data?.name}
                </Text>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <CalendarIcon fill="pink" />
                    <Text $fontSize="12px" $color="pink" style={{ marginLeft: '5px' }} $bold>
                        {!_.isEmpty(data) &&
                            `${
                                dayjs(data.startDate).isSame(dayjs(), 'day')
                                    ? 'Today'
                                    : dayjs(data.startDate).format('DD MMM YYYY')
                            }, ${dayjs()
                                .set({
                                    hour: data.startTime.split(':')[0],
                                    minute: data.startTime.split(':')[1],
                                })
                                .format('HH:mm')} - ${dayjs()
                                .set({
                                    hour: data.endTime.split(':')[0],
                                    minute: data.endTime.split(':')[1],
                                })
                                .format('HH:mm')}`}
                    </Text>
                </div>
                <Text $fontSize="12px" $color="gray2">
                    {data?.description}
                </Text>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        columnGap: '10px',
                        width: '100%',
                        marginTop: '10px',
                    }}
                >
                    <OutlinedButton onClick={onCancelConfirm} $width="80px">
                        Cancel
                    </OutlinedButton>

                    {onConfirm && (
                        <ContainedButton onClick={onConfirm} $width="90px">
                            Confirm
                        </ContainedButton>
                    )}
                </div>
            </StyledCardContent>
        </StyledCard>
    );
};

OverlapCard.propTypes = {
    data: PropTypes.object,
    onCancelConfirm: PropTypes.func,
    onConfirm: PropTypes.func,
};
